<dx-popup #dlgDisclaimerAcceptance [width]="600" [height]="440" [showTitle]="true" title="Disclaimer Required"
    [resizeEnabled]=true (onShowing)="onShowing($event)" (onHiding)="onHiding($event)" [dragEnabled]="true"
    [showCloseButton]="true" [hideOnOutsideClick]="false" [animation]="null">
    <div *dxTemplate="let data of 'content'">
        <div style="width:100%; height:240px; overflow-y:scroll">
            <div>
                <div>
                    <p>
                        {{Paragraph1Text}}
                    </p>
                    <p>
                        Please write the following unique disclaimer code onto any printed disclaimers for your
                        reference: {{DisclaimerCode}}
                    </p>
                    <ul>
                        <li *ngFor="let DisclaimerText of DisclaimerTextList">
                            {{DisclaimerText}}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <br />

        <div style="display:flex; flex-direction: row; justify-content: space-between;">
            <dx-select-box [id]="acceptanceType" #sbxAcceptanceType style="margin:5px;" [dataSource]="dsAcceptanceTypes"
                showClearButton="true" value="-1" width="250" displayExpr="Name" valueExpr="Id">
            </dx-select-box>

            <dx-check-box [id]="chkSigned" #chkSignedDisclaimer text="The client has accepted the disclaimer(s)"
                [value]="false" style="margin:5px; ">
            </dx-check-box>
        </div>

        <br />
        <div style="display: flex; flex-direction: row; justify-content: flex-end;">
            <dx-button (onClick)="btnContinue($event)" text="Continue"
                [disabled]="chkSignedDisclaimer.value==false || sbxAcceptanceType.value<0 || sbxAcceptanceType.value>1 || sbxAcceptanceType.value==null "
                [value]="false" (onValueChanged)="onValueChanged($event)">
            </dx-button>
            &nbsp;
            <dx-button (onClick)="btnCancel($event)" text="Cancel">
            </dx-button>
        </div>
    </div>
</dx-popup>